import React from "react";
import "./successBadge.scss";

import BeenhereOutlinedIcon from "@mui/icons-material/BeenhereOutlined";
import { Stack } from "react-bootstrap";
import { t } from "i18next";

const SuccessBadge = () => {
  return (
    <Stack
      gap={4}
      className="d-flex justify-content-center align-items-center pt-3 pb-3 ps-2 pe-2"
    >
      <div className="circular-badge">
        <BeenhereOutlinedIcon sx={{ width: 50, height: 50 }} />
      </div>
      <p className="w-75 text-center fw-semibold">
        {t("user_question.success_text")}
      </p>
    </Stack>
  );
};

export default SuccessBadge;
